import {Request, Resource} from 'simpli-web-sdk'

export class ApiPermission extends Resource {
  idEndpointPk: number = 0
  desc: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idEndpointPk
  }
  set $id(val) {
    this.idEndpointPk = val
  }

  static async listApiPermission() {
    return await Request.get(`/admin/responsavel/api-permission`)
      .name('listApiPermission')
      .asArrayOf(ApiPermission)
      .getData()
  }
}
